import { createSelector, createFeatureSelector } from '@ngrx/store';
import { CoreState } from '../reducers';
import { TranslationState, translationInitialState } from './translation.reducers';

const selectCoreState = createFeatureSelector<CoreState>('core');

const selectTranslationState = createSelector(
    selectCoreState,
    (state: CoreState) => state && state.translation ? state.translation : translationInitialState
);

export const selectTranslation = (lang: string) => createSelector(
    selectTranslationState,
    (state: TranslationState) => {
        return state.translations[lang];
    }
);

